import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import {
  Alert,
  alertTypes,
  alertVariants,
} from "@visiblethread/react-components/dist/components/Alert";
import { hideModal } from "slices/app/actions/modals";
import { saveSnapshot } from "slices/discovery/actions/snapshot";
import { modalTypes } from "constants/types";
import { removeErrorMessage } from "slices/app/errorSlice";

const SaveSnapshotModal = () => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const errorMessage = useSelector((state) => state.error.errorMessage);

  const isEnabled = () =>
    name.trim() !== "";

  const handleNameChange = ({ target: { value } }) => {
    setName(value);
  };

  const handleCancel = () => {
    dispatch(removeErrorMessage);
    dispatch(hideModal(modalTypes.SAVE_SNAPSHOT));
  };

  const handleSave = () => {
    if (isEnabled()) {
      dispatch(saveSnapshot(name.trim()));
    }
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter") {
      handleSave();
    }
  };

  return (
    <Modal
      centered
      show
      backdrop="static"
      className="fade-in"
      data-testid="save-snapshot-modal"
      onDismiss={handleCancel}
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header closeButton>
        <b>Save current snapshot</b>
      </Modal.Header>
      <Modal.Body>
        {errorMessage && (
          <Alert
            variant={alertVariants.warning}
            text={errorMessage}
            type={alertTypes.inline}
            hideCloseButton
          />
        )}
        <input
          autoFocus
          value={name}
          type="text"
          required
          placeholder="Enter snapshot name"
          className="form__field_text"
          onChange={handleNameChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          content="Save"
          variant={buttonVariants.primary}
          onClick={handleSave}
          disabled={!isEnabled()}
        />
        <Button
          content="Cancel"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default SaveSnapshotModal;
